<template>
	<v-card class="elevation-3" color="white">
		<v-img class="white--text align-end" height="200px" :src="tenant.settings.brandImages.dashboardImage.professional">
			<div class="text-center ma-4 title">
				<h3>When are you available to Locum?</h3>
			</div>

			<div class="text-center ma-4">
				<v-btn rounded color="white" class="black--text text-none mb-7" @click="locumSetAvailability()"
					>Set your availability
					<!-- <v-icon right>mdi-arrow-right</v-icon> -->
				</v-btn>
			</div>
		</v-img>
	</v-card>
</template>

<script>
import { bus } from '@/main';
import { Tracking } from '@/utils';

export default {
	name: 'LocumActionAvailabilityCard',
	components: {},
	data: () => ({}),
	created() {},
	beforeDestroy() {
		// bus.$off('intent:submit-forms');
	},
	methods: {
		locumSetAvailability() {
			Tracking.track('Locum_Set_Availability_Click', {});
			bus.$emit('change-context', 'locum-set-availability');
		},
	},
};
</script>
